import React, { useState, useEffect, useMemo, useRef, Fragment } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography, Drawer, Checkbox, FormControlLabel, ClickAwayListener, Grow, Paper, Popper, Badge } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import CustomCheckbox from '../CustomCheckbox';
import ChangeViewArray from '../ChangeViewArray';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '../../icons/SearchIcon';
import FilterIcon from '../../icons/FilterIcon';
import AddAllAppsIcon from '../../icons/AddAllAppsIcon';
import IconButton from '@material-ui/core/IconButton';
import FilterStatuses from '../Filter/FilterStatuses';
import FilterShow from '../Filter/FilterShow';
import FilterShowVideo from '../Filter/FilterShowVideo';
import FilterShowCloudApps from '../Filter/FilterShowCloudApps';
import FilterShowApplicationsRadio from "../Filter/FilterShowApplicationsRadio";
import FilterInterface from "../Filter/FilterInterface";
import FilterArchitecture from "../Filter/FilterArchitecture";
import FilterArchive from "../Filter/FilterArchive";
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import translate from '../../other/translate.json'
import AllAppsTable from "./AllAppsTable";
import AllAppsTile from "./AllAppsTile";
import AllAppsTbl from "./AllAppsTbl";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import clsx from "clsx";
import CloseIcon from '../../icons/CloseIcon';
import SkeletonCardTable from '../Skeleton/SkeletonCardTable';
import SkeletonCardTile from '../Skeleton/SkeletonCardTile';
import Divider from "@material-ui/core/Divider";
import FormControl from '@material-ui/core/FormControl';
import ChipArrayRed from '../ChipArrayRed';
import SubFilterList from '../SubFilterListVers3';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import FilterErr from "../Errors/FilterErr";
import utils from '../../other/utils';
import config from '../../other/config';
import AppCard from "./AppCard";
import KloBanksChoose from '../KloBanksChoose';
import CustomAutocomplete from '../CustomsearchAutocomplete';
import CustomSelect from '../CustomSelect';
import Axios from "axios";
import ShareIcon from '../../icons/ShareIcon';
let isInitialstate = true;
const compareApps = utils.compareApps

const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 32,
		right: -6,
		height: 10,
		width: 10,
		borderRadius: 5,
		backgroundColor: '#EB505E'
	},
}))(Badge);

const CustomIconButton = withStyles((theme) => ({
	root: {
		// color: theme.palette.getContrastText(purple[500]),
		// backgroundColor: purple[500],
		color: '#BCBBD0',
		backgroundColor: '#FFFFFF',
		//boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
		//marginLeft: 8,
		// '&:hover': {
		//   backgroundColor: purple[700],
		// },
	},
}))(IconButton);

const FilterButton = withStyles({
	root: {
		width: '100%',
		borderRadius: '48px',
		boxShadow: 'none',
		textTransform: 'none',
		fontSize: '18px',
		// padding: 24,
		border: 'none',
		lineHeight: '39px',
		backgroundColor: '#8987A2',
		borderColor: '#0063cc',
		fontFamily: 'Cera CY',
		color: '#FFFFFF',
		fontStyle: 'normal',

		'&:hover': {
			backgroundColor: '#8987A2',
			// borderColor: '#8987A2',
			// boxShadow: 'none',
		},

		// '&:active': {
		//   boxShadow: 'none',
		//   backgroundColor: '#8987A2',
		//   borderColor: '#005cbf',
		// },

		// '&:focus': {
		//   boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
		// },
	},
})(Button);


const { serverAPI } = config;



function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};
// const getArrCard = async (listNum, bank, researchmarket, ready, archive, preview, standart, promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom) => await axios.get(`${serverAPI}/applications_V2?vers=&interfaceChecked=&ArchChecked=&appFilterSN=&appFilterBN=&appFilterBNs=&sort=ID&desc=desc&selector=StockLink,DateCreate,IsResearchMarket,CodeAsvul,Version,DateStartSale,DateEndSale,Type,snname,bnname,BusinessDirectionAdditional,IsStandartPackage,R1,Architecture,Interface,AlternativeLink,PaymentOne,PaymentMonthly,PaymentComment_Ru,PaymentCommentOne_Ru,PaymentCommentMonthly_Ru,PaymentComment_Eng,PaymentCommentOne_Eng,PaymentCommentMonthly_Eng,StockLink,DateStartStock,DateEndSaleStock,PaymentOneStock,PaymentMonthlyStock,Title_ru,BriefDescription_Ru,Tags,Title_eng,BriefDescription_Eng&promotion=${promotion}&researchmarket=${researchmarket}&preview=${preview}&ready=${ready}&stndrt=${standart}&platform=${platform}&msa=${msa}&page=${listNum}&search=&countRecord=24&systems=${bank}&multistreamno=${multistreamno}&multistream=${multistream}&web=${web}&nav=${nav}&section=${idsSection}&version=${idsVersion}&direction=${idsDirection}&dateto=${dateto}&datefrom=${datefrom}`);
export default function AppListContent(props) {
	let canUpdateData = true;
	var d = new Date();
	var year = d.getFullYear();
	var month = d.getMonth()// > 8 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
	var day = d.getDate();

	const linkFilters = props.savedFilters;
	const hasSavedFilters = linkFilters !== null;
	let fulldate = new Date(year - 1, month, day);
	let fullDateNext = new Date(year + 1, month, day);
	if (hasSavedFilters && linkFilters.dateto !== '') {
		fullDateNext = new Date(linkFilters.dateto.split('-')[0], + linkFilters.dateto.split('-')[1] - 1, linkFilters.dateto.split('-')[2])
	}
	if (hasSavedFilters && linkFilters.datefrom !== '') {
		fulldate = new Date(linkFilters.datefrom.split('-')[0], +  linkFilters.datefrom.split('-')[1] - 1, linkFilters.datefrom.split('-')[2])
	}
	let [datefrom, _datefrom] = useState(hasSavedFilters ? linkFilters.datefrom : ``);
	let [dateto, _dateto] = useState(hasSavedFilters ? linkFilters.dateto : ``);
	const isRBS = window.location.href.indexOf('bank-DBI') > -1;
	const isCFTBank = window.location.href.indexOf('cftbank') > -1;
	const isInsurance = window.location.href.indexOf('insurance') > -1
	const isServiceSuite = window.location.href.indexOf('zk') > -1;
	const isBudget = window.location.href.indexOf('budget') > -1;
	const isManagementRisks = window.location.href.indexOf('cft-management-risks') > -1;
	const isArchive = props.info.isArchive !== undefined ? props.info.isArchive : isInsurance ? true : false;
	const isArchive2 = props.info.isArchive === 1;
	const kloUser = props.kloUser;
	const { currentServerPart, user } = kloUser;
	const availableStatuses = user && user.IS_CFT === '1' ? ["Куплено (используется)", "Куплено (не используется)", "Не куплено (используется)", "Не куплено (не используется)", "В процессе оформления покупки (используется)", "В процессе оформления покупки (не используется)", "Нет данных"] : ["Куплено", /*"Не куплено",*/"Не куплено (используется)", "Не куплено (не используется)", "В процессе оформления покупки (используется)", "В процессе оформления покупки (не используется)", "Нет данных"]
	const getParamURLQuery = (srt, param) => {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			//if (param === 'direction=') {
			return (+Val)
			//}
		}
	}

	let { info, bank, catalog } = props
	const hasVideo = props.info.hasVideo === 1 // has apps with Video
	const hasCloudApps = props.info.hasCloudApp === 1 // has cloud apps
	let [view, _view] = useState(localStorage.getItem('view') || 'tile')
	const language = localStorage.getItem('language') || 'Ru'
	let history = useHistory()
	const classes = useStyles();
	const [filterOpen, setFilterOpen] = React.useState(false);
	const [searchFocus, setSearchFocus] = useState(false);
	const [screenSectionVisible, setScreenSectionVisible] = React.useState(false);
	const [screenDirectionVisible, setScreenDirectionVisible] = React.useState(false);
	const [screenVersionBeforeVisible, setScreenVersionBeforeVisible] = React.useState(false);
	const [cardArr, setCardArr] = useState([]);
	const [cardArr2, setCardArr2] = useState([]);
	const [cardArr3, setCardArr3] = useState([]);
	const [sectionArr, setSectionArr] = useState([]);
	const [directionArr, setDirectionArr] = useState([]);
	const [versionArr, setVersionArr] = useState([]);
	const [loading, setloading] = React.useState(true);
	const [snackbar, _snackbar] = React.useState([false, '']);
	const [filterStatusKlo, _filterStatusKlo] = useState([]);
	let [researchmarket, _researchmarket] = useState(hasSavedFilters ? '' + linkFilters.researchmarket : '0');
	let [preview, _preview] = useState(hasSavedFilters ? '' + linkFilters.preview : '0');
	let [ready, _ready] = useState(hasSavedFilters ? '' + linkFilters.ready : '0');
	let [archive, _archive] = useState(isArchive ? '' : hasSavedFilters ? linkFilters.archive : 0);
	let [standart, _standart] = useState(hasSavedFilters ? linkFilters.stndrt : '0');
	let [addStandart, _addStandart] = useState(hasSavedFilters ? linkFilters.addstndrtpackage : '0');
	let [nav, _nav] = useState(hasSavedFilters ? linkFilters.nav : '0');
	let [web, _web] = useState(hasSavedFilters ? linkFilters.web : '0');
	let [platform, _platform] = useState(hasSavedFilters ? linkFilters.platform : '0');
	let [msa, _msa] = useState(hasSavedFilters ? linkFilters.msa : '0');
	let [microservice, _microservice] = useState(hasSavedFilters ? linkFilters.microservice : '0');
	let [other, _other] = useState('0');
	let [promotion, _promotion] = useState(hasSavedFilters ? linkFilters.promotion : '0');
	let [video, _video] = useState(hasSavedFilters ? linkFilters.video : '0');
	let [hasCloud, _hasCloud] = useState(hasSavedFilters ? linkFilters.hasCloud : '0');
	let [multistream, _multistream] = useState(hasSavedFilters ? '' + linkFilters.multistream : '0');
	let [multistreamno, _multistreamno] = useState(hasSavedFilters ? '' + linkFilters.multistreamno : '0');
	// let [datefrom, _datefrom] = React.useState('');
	// let [dateto, _dateto] = React.useState('');
	let [idsVersion, _idsVersion] = React.useState(hasSavedFilters ? linkFilters.version : []);
	let directionArray = [];
	let sectionArray = [];
	if (history.location.search.includes('direction=') && !history.location.search.includes('section=')) {
		directionArray.push({ ID_BN: getParamURLQuery(history.location.search, 'direction=') })
	} else if (history.location.search.includes('section=')) {
		sectionArray.push({
			ID: getParamURLQuery(history.location.search, 'section=')
		});
	}
	let [idsDirection, _idsDirection] = React.useState(hasSavedFilters ? linkFilters.direction : directionArray);
	let [idsSection, _idsSection] = React.useState(hasSavedFilters ? linkFilters.section : sectionArray);
	let [statusFilter, setStatusFilter] = React.useState(false);
	let [idsVersionFilter, _idsVersionFilter] = React.useState([]);
	let [idsDirectionFilter, _idsDirectionFilter] = React.useState(false);
	let [idsSectionFilter, _idsSectionFilter] = React.useState([]);
	const [initial, _initial] = useState(true);
	let valueFilterStatuses_ = 1

	if (hasSavedFilters && linkFilters.researchmarket === 1) {
		valueFilterStatuses_ = 2
	}

	if (hasSavedFilters && linkFilters.preview === 1) {
		valueFilterStatuses_ = 3
	}

	if (hasSavedFilters && linkFilters.ready === 1) {
		valueFilterStatuses_ = 4
	}

	const [valueFilterStatuses, setValueFilterStatuses] = React.useState(valueFilterStatuses_);
	let valueFilterShowApplications_ = 1;

	if (hasSavedFilters && linkFilters.multistreamno === 1) {
		valueFilterShowApplications_ = 3;
	}

	if (hasSavedFilters && linkFilters.multistream === 1) {
		valueFilterShowApplications_ = 2;
	}

	const [valueFilterShowApplications, setValueFilterShowApplications] = React.useState(valueFilterShowApplications_);
	let valueFilterArchive_ = 1;
	if ((hasSavedFilters && linkFilters.archive === 1) || archive === 1) {
		valueFilterArchive_ = 2;
	}

	const [valueFilterArchive, setValueFilterArchive] = React.useState(valueFilterArchive_);
	const [rusSearch, _rusSearch] = useState('');
	let [allCheckBox, setAllCheckBox] = useState(false);
	let [checkAll, setCheckAll] = useState(false);
	const [page, setPage] = React.useState(1);
	const [countApp, setcountApp] = React.useState(0);
	const [showAccurateSearchMenu, _showAccurateSearchMenu] = useState(false);
	const [accurateSearch, _accurateSearch] = useState(false);
	const [anchorMenu, _anchorMenu] = React.useState(null);
	// const [firts, setFirts] = React.useState(1);
	const [selectedDateFrom, handleDateChangeFromVal] = useState(fulldate);
	const [selectedDateTo, handleDateChangeToVal] = useState(fullDateNext);
	// let [searchText, setSearchText] = React.useState('');
	let [findText, setFindText] = React.useState(hasSavedFilters ? linkFilters.search : '');
	let [text, setText] = useState(hasSavedFilters ? linkFilters.search : '');
	const [arrayTag, setArrayTags] = useState(JSON.parse(localStorage.getItem('AppsArrayTag')) || []);
	const [disablePriorityBtn, _disablePriorityBtn] = useState([]);
	const [kloStatuses, _kloStatuses] = useState({});
	const [loadingKloStatuses, _loadingKloStatuses] = useState(false);
	let [sortingSelectVal, _sortingSelectVal] = useState(hasSavedFilters ? linkFilters.sort + linkFilters.desc[0] : 'codeAsvulSortA');
	const CancelToken = axios.CancelToken;
	const source = CancelToken.source();
	let arrayTags = arrayTag.map(el => el.key).join()

	const changePage = (event, value) => {
		setPage(value);
		window.scrollTo(0, 0);
	};

	const setArrayTag = (arr) => {
		// setListNumProps(0)
		setPage(1)
		setArrayTags(arr)
		localStorage.setItem('AppsArrayTag', JSON.stringify(arr))
		// console.log(arr)
	}

	function clearChips() {
		setPage(1)
		setArrayTags([])
		localStorage.setItem('AppsArrayTag', '[]')
	}

	const closeSnackbar = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		_snackbar([false, '']);
	};


	const handleDateChangeTo = (date) => {
		source.cancel('Operation canceled by the user.');
		handleDateChangeToVal(date)
		setStatusFilter(true)
		setPage(1)

		_dateto(date.format('YYYY-MM-DD'))
		if (date < selectedDateFrom) {
			_datefrom(date.format('YYYY-MM-DD'))
			handleDateChangeFromVal(date)
		}
	}

	const handleDateChangeFrom = (date) => {
		source.cancel('Operation canceled by the user.');
		setStatusFilter(true)
		setPage(1)

		// setListNum(0)
		_datefrom(date.format('YYYY-MM-DD'))
		handleDateChangeFromVal(date)
		if (date > selectedDateTo) {
			_dateto(date.format('YYYY-MM-DD'))
			handleDateChangeToVal(date)
		}
		// if (date < fulldate) {
		// 	_archive('1')
		// } else {
		// 	_archive('0')
		// }


		// 
	}

	const getArrCard =
		async (countRecord__, listNum, bank, researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, findText, lang, arrayTags, video, microservice, hasCloud,accurateSearch) =>
			await axios.get(`${serverAPI}/app/${props.selectedIndex}/${lang}?&inCu=${props.userCollection.inCu}&search=${encodeURIComponent(utils.validateSearchVal(findText,true))}&sort=${sortingSelectVal.slice(0, -1)}&desc=${sortingSelectVal.at(-1) === 'A' ? 'ASC' : 'DESC'}&promotion=${promotion}&researchmarket=${researchmarket}&preview=${preview}&ready=${ready}&stndrt=${standart}&addstndrtpackage=${addStandart}&platform=${platform}&msa=${msa}&page=${listNum}&countRecord=${countRecord__}&systems=${bank}&multistreamno=${multistreamno}&multistream=${multistream}&web=${web}&nav=${nav}&section=${idsSection.map(el => el.ID)}&version=${idsVersion.map(el => el.ID)}&direction=${idsDirection.map(el => el.ID_BN)}&dateto=${dateto}&datefrom=${datefrom}&archive=${archive}&tags=${arrayTags}&video=${video}&microservice=${microservice}&hasCloud=${hasCloud}&accurateSearch=${accurateSearch ? 1 : 0}${initial && window.location.href.indexOf('filters=') > -1 && isInitialstate ? `&filters=${window.location.href.split('filters=')[1]}` : ''}`, { cancelToken: source.token });

	const getArrCardID =
		async (listNum, bank, researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, findText, lang, arrayTags, microservice, isCountForBasket = false) =>
			await axios.get(`${serverAPI}/allapps/${props.selectedIndex}/${lang}?search=${findText}&sort=${sortingSelectVal.slice(0, -1)}&desc=${sortingSelectVal.at(-1) === 'A' ? 'ASC' : 'DESC'}&promotion=${promotion}&researchmarket=${researchmarket}&preview=${preview}&ready=${ready}&stndrt=${standart}&addstndrtpackage=${addStandart}&platform=${platform}&msa=${msa}&page=${listNum}&countRecord=16&systems=${bank}&multistreamno=${multistreamno}&multistream=${multistream}&web=${web}&nav=${nav}&section=${idsSection.map(el => el.ID)}&version=${idsVersion.map(el => el.ID)}&direction=${idsDirection.map(el => el.ID_BN)}&dateto=${dateto}&datefrom=${datefrom}&archive=${archive}&tags=${arrayTags}&video=${video}&microservice=${microservice}${isCountForBasket ? '&needCount=1' : ''}`);

	const setView = (index) => {
		if (index === 'tbl') setPage(1);
		_view(index)
		localStorage.setItem('view', index)
	}

	const FilterHeader = () => (
		<Grid container direction="row" justify="space-between" alignItems="center" style={{ padding: '12px 12px 12px 24px' }} /* style={{ position: 'fixed', width: 334, background: '#FFF', paddingTop: 32, paddingLeft: 24, zIndex: 2 }} */>
			<Grid item>
				<Typography className={classes.filterHeader}>
					{translate.Words[`Filter${language}`]}
					<CustomTooltip title={translate.Words[`ShareLink_${language}`]}>
						<CustomIconButton aria-label={translate.Words[`ShareLink_${language}`]} onClick={() => saveFilters()}>
							<ShareIcon fill='#BCBBD0' />
						</CustomIconButton>
					</CustomTooltip>
				</Typography>
			</Grid>

			<Grid item className={classes.btnClose}>
				<IconButton onClick={() => setFilterOpen(false)} aria-label="filter">
					<CloseIcon fill='#BCBBD0' />
				</IconButton>
			</Grid>
		</Grid>
	);

	const handleKeyDown = (val) => {
		// if (event.key === 'Enter' && val !== "") {
		setFindText(val)
		// setListNumProps(0)
		//}
	}

	const setScreenVersionBeforeVisibleProps = () => {
		//console.log('setScreenVersionBeforeVisibleProps')
		setScreenVersionBeforeVisible(!screenVersionBeforeVisible)
	}

	const setScreenSectionVisibleProps = () => {
		//console.log('setScreenSectionVisible')
		setScreenSectionVisible(!screenSectionVisible)
	}

	const setScreenDirectionVisibleProps = () => {
		//console.log('setScreenDirectionVisible')
		setScreenDirectionVisible(!screenDirectionVisible)
	}

	const resetStateNew = () => {
		setValueFilterStatuses(1);
		setValueFilterShowApplications(1);
		setValueFilterArchive(1);
		_researchmarket('0')
		_ready('0')
		_archive('0')
		_idsSection([])
		_idsVersion([])
		_idsDirection([])
		_preview('0')
		_archive(isArchive ? '' : 0);
		_standart('0');
		_addStandart('0');
		_promotion('0');
		_multistream('0');
		_multistreamno('0');
		_nav('0');
		_web('0');
		_platform('0');
		_msa('0');
		_microservice('0');
		_other('0');
		setStatusFilter(false)
		_datefrom('')
		_dateto('')
		_video('0')
		_hasCloud('0')
		_filterStatusKlo([])

	}

	const clearSearch = () => {
		setSearchFocus(false);
		setFindText('')
		setText('')
		_accurateSearch(false);
		textInput.current.clearValue();
	}

	const sortArrayByDirection = (arr, directions) => {
		if (directions.length > 0 && Array.isArray(arr)) {
			const dirIds = directions.map(el => el.ID_BN)
			/*let newArr = arr.filter(el => dirIds.includes(el.businessdirectionid)).concat(arr.filter(el => {
				if (el && el.BusinessDirectionAdditionalids && el.BusinessDirectionAdditionalids.indexOf(',') > -1) {
					console.log("if", el ,el.BusinessDirectionAdditionalids )
					let dopBusines = el.BusinessDirectionAdditionalids.split(',');
					dopBusines.map(elem => {
						if (dirIds.includes(+elem)) {
							return true
						}
					})
					return false

				} else {
					console.log("else", el, el.BusinessDirectionAdditionalids !== '' &&  dirIds.includes(el.BusinessDirectionAdditionalids))
					return el.BusinessDirectionAdditionalids !== '' &&  dirIds.includes(+el.BusinessDirectionAdditionalids)
				}
				
			}));*/

			let newArr = arr.filter(el => dirIds.includes(el.businessdirectionid)).concat(arr.filter(el => !dirIds.includes(el.businessdirectionid)))
			//console.log("sortArrayByDirection",dirIds, arr, newArr)
			return newArr
		} else {
			return arr
		}
	}

	const saveFilters = async () => {
		let newFiltersReq = await Axios.post(`${serverAPI}/saveFilters`, { bank, researchmarket, ready, archive, preview, stndrt: standart, addstndrtpackage: addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, section: idsSection, version: idsVersion, direction: idsDirection, dateto, datefrom, search: findText, language, tags: arrayTags, video, microservice, hasCloud, sort: sortingSelectVal.slice(0, -1), desc: sortingSelectVal.at(-1) === 'A' ? 'ASC' : 'DESC' })

		let link = `${window.location.href.split('filters=')[0]}${window.location.href.indexOf('?') > 0 ? '&' : '?'}filters=${newFiltersReq.data.newLink}`
		//utils.copyToClipBoard(link)
		try {
			const permissions = await navigator.permissions.query({ name: "clipboard-write" })
			if (permissions.state === "granted" || permissions.state === "prompt") {
				await navigator.clipboard.writeText(link);
				props.userCollection.showSnackbarMessage(translate.Words[`CopiedToClipboard_${language}`]);
			} else {
				props.userCollection.showSnackbarMessage(translate.Words[`NotAccessClipboard_${language}`]);
			}
		} catch (error) {
			props.userCollection.showSnackbarMessage(translate.Words[`ErrorCopyingClipboard_${language}`] + error);
		};

	}

	const getRelevantNumEqual = (a) => {
		const prepareVal = (val) => typeof val === 'string' ? val : ''
		let aCode = a.codeasvul.toUpperCase();			
		let aTitle = prepareVal(a.title).toUpperCase();		
		let search = findText.toUpperCase();
		let aTags = prepareVal(a.tags).toUpperCase();
		let aDesc = prepareVal(a.briefdescription).toUpperCase() + prepareVal(a.HTMLFunction).toUpperCase() + prepareVal(a.HTMLContent).toUpperCase();
		let result = 0;
		if (aCode === search) {
			result = 10000;
		} else if (aCode.indexOf(search) > -1) {
			result = 5000;
		} else if (aTitle === search) {
			result = 1000;
		} else if (aTitle.indexOf(search) > -1) {
			result = 500;
		} else if (aDesc.indexOf(search) > -1) {
			result = 100;
		} else if (aTags.indexOf(search) > -1) {
			result = 10;
		}
		return result
			
	}
	const sortArray = (array) => {
		let sortedArray = array.sort(compareApps);
		let direction = history.location.search.includes('direction=') && getParamURLQuery(history.location.search, 'direction=') !== '' ? getParamURLQuery(history.location.search, 'direction=') : undefined;
		return direction !== undefined ? sortedArray.filter(elem => elem.businessdirectionid === direction).concat(sortedArray.filter(elem => elem.businessdirectionid !== direction)) : sortedArray
	}

	useEffect(() => {
		let didCancel = false;

		async function fetchData() {
			

			setloading(true)
			let dataCard1 = []
			let dataCardID = []
			//_kloStatuses({});
			if (view === 'tbl') {
				window.location.pathname.indexOf("/applications/apptags") > -1
					?
					dataCard1 = await getArrCard(9999, page - 1, '', researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, [], idsVersion, [], dateto, datefrom, findText, language, arrayTags, video, microservice, hasCloud)
					:
					dataCard1 = await getArrCard(9999, page - 1, bank, researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, findText, language, [], video, microservice, hasCloud)
				if (dataCard1.data.searchValue !== undefined && dataCard1.data.records.length > 0) {
					_rusSearch(dataCard1.data.searchValue)
				} else {
					_rusSearch('')
				}

				let apps = dataCard1.data.records;
				if (findText && findText.length > 2) {
					apps = apps.sort(compareApps).map(el => {el.relev = getRelevantNumEqual(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev)
					_sortingSelectVal('recomended')
					

				} else {
					apps = sortArrayByDirection(dataCard1.data.records.sort(compareApps), idsDirection) || [];
					
					
				}

				setCardArr2(dataCard1.data.records || [])
				setcountApp(dataCard1 && dataCard1.data && dataCard1.data.records ? dataCard1.data.records.length : '')
				setCardArr(apps)
				setCardArr3(apps)

				if (apps?.length > 0) { setloading(false) }

				let basketApp = JSON.parse(localStorage.getItem('cartApp')) || []
				let isAllBasket = dataCard1 && dataCard1.data && dataCard1.data.records.filter(el => el.researchmarket == "")
				let isAll = isAllBasket && isAllBasket.every(el => basketApp.includes(el.ID))

				setAllCheckBox(isAll)
			} else {
				if (window.location.pathname.indexOf("/applications/apptags") > -1) {
					dataCard1 = await getArrCard(9999, 0, '', researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, [], idsVersion, [], dateto, datefrom, findText, language, arrayTags, video, microservice, hasCloud,accurateSearch)
				} else {
					dataCard1 = await getArrCard(9999, 0, bank, researchmarket, ready, archive, preview, standart, addStandart, promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, findText, language, [], video, microservice, hasCloud,accurateSearch);
				}
				isInitialstate = false;
				//dataCardID = dataCard1.map(elem => elem.ID)//await getArrCardID(0, bank, researchmarket, ready, archive, preview, standart, addStandart,promotion, multistream, multistreamno, msa, platform, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, findText, language, arrayTags, microservice)
				if (dataCard1.data.searchValue !== undefined && dataCard1.data.records.length > 0) {
					_rusSearch(dataCard1.data.searchValue)
				} else {
					_rusSearch('')
				}
				if (initial && linkFilters !== null) {
					textInput.current.setValue(linkFilters.search);//document.getElementById('appsSearchInput').innerHTML = linkFilters.search;
				}
				let apps = dataCard1.data.records;
				if (findText && findText.length > 2) {
					const compareApps = utils.compareApps
					apps = apps.sort(compareApps).map(el => {el.relev = getRelevantNumEqual(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev)
					_sortingSelectVal('recomended')
					console.log(apps, sortingSelectVal)
				} else {
					apps = sortArrayByDirection(dataCard1.data.records.sort(compareApps), idsDirection) || [];

					

					if (sortingSelectVal.at(-1) === 'A') {
						if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
							sortArray(dataCard1.data.records)
						} else {
							apps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] < b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
						}
					} else {
						if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
							apps.reverse()
						} else {
							apps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] > b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
						}
					}
				}

				setcountApp(dataCard1 && dataCard1.data && dataCard1.data.records ? dataCard1.data.records.length : '')
				// setCardArr(sortArray(dataCard1.data.records))
				setCardArr(apps)
				setCardArr2(apps)
				setCardArr3(apps)
				_initial(false)
				setloading(false)

				//const statuses = await axios.post(`https://lk.cft.ru/api/get_lk_apps?month=12.2022`,{apps:dataCard1.data.records.slice(0,25).map(el => el.codeasvul).join(',')})
			}

			if (dataCard1 && dataCard1.data) {
				setStatusFilter(datefrom.length + dateto.length + idsSection.length + idsVersion.length + idsDirection.length + +researchmarket + +ready + +archive + +preview + +standart + +addStandart + +promotion + +multistream + +multistreamno + +nav + +web + +platform + +msa + +hasCloud + +video + +microservice + +other > 0)
			}
		}


		if (!didCancel && canUpdateData) {
			fetchData();
		}

		return () => {
			didCancel = true;
		};
		// }
	}, [language, findText, researchmarket, preview, ready, standart, addStandart, promotion, multistream, multistreamno, msa, platform, microservice, web, nav, idsSection, idsVersion, idsDirection, dateto, datefrom, bank, archive, findText, video, hasCloud, accurateSearch,  window.location.pathname.indexOf("/applications/apptags") > -1 ? arrayTags : null]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			const dataFilter = await axios.get(`${serverAPI}/filter_app?lang=${language}&inCu=${props.userCollection.inCu}&systema=${bank}&web=${web}&nav=${nav}&section=${[]/*idsSection.map(el => el.ID)*/}&version=${[]/*idsVersion.map(el => el.ID)*/}&direction=${[]/*idsDirection.map(el => el.ID_BN)*/}&archive=${isArchive2 ? 1 : archive}&ready=${ready}&researchmarket=${researchmarket}&announcement=${preview}&stndrtpackage=${standart}&addstndrtpackage=${addStandart}&promo=${promotion}&multistream=${multistream}&msa=${msa}&platform=${platform}&microservice=${microservice}`, { cancelToken: source.token })
			const sortVersions =(arr) => {
				const getEqualNumberByVers = (vers) => {
					if (vers.split(' ').length === 2) {
						vers = vers.split(' ')[1]
					}
					let number = vers.replace(new RegExp('[^0-9.]', "gmi"),'')
					let arrNum = number.split('.').filter(el => el !== '');
					let result = []
					for (let part of arrNum) {
						while (part.length < 3 )  {
							part = '0' + part
						}
						result.push(part)
					}
					// console.log(vers,number,result.join('.'))
					return result.length === 0 ? number : result.join('.')
				}
				const compareVers = (a,b) => {
					let aVers = a.equalVers
					let bVers = b.equalVers
					if (aVers > bVers) {
						return -1
					}
					if (aVers < bVers) {
						return 1
					}
					return 0
				}
				let catalogVers = dataFilter.data.Version.filter(el => ['aav',bank ].includes(el.url_catalog)).map(el => { el.equalVers = getEqualNumberByVers(el.Version);return el}).sort(compareVers)
				let anotherVers = dataFilter.data.Version.filter(el => !['aav',bank ].includes(el.url_catalog)).map(el => { el.equalVers = getEqualNumberByVers(el.Version);return el}).sort(compareVers)
				// console.log(anotherVers,catalogVers)
				return catalogVers.concat(anotherVers)
			}
			if (!didCancel) {
				let sVers = sortVersions(dataFilter.data.Version)
				// console.log(sVers)
				setVersionArr(sVers)
				// if (firts === 0) {
				setDirectionArr(dataFilter.data.Direction)
				// }
				//if (idsSection.length === 0) {
				setSectionArr(dataFilter.data.Section)
				//}
				if (history.location.search.includes('direction=') && !history.location.search.includes('section=')) {
					try {
						idsDirection[0].Title = dataFilter.data.Direction.filter(elem => elem.ID_BN === idsDirection[0].ID_BN)[0].Title  // КОСТЫЛЬ !!!! 
					} catch (e) {
						console.log(e)
					}

				} else if (history.location.search.includes('section=')) {
					try {
						idsSection[0].TitileSectionRu = dataFilter.data.Section.filter(elem => elem.ID === idsSection[0].ID)[0].TitileSectionRu
					} catch (e) {
						console.log(e)
					}

				}
				props.userCollection.showTestId()
			}
		}
		fetchData();
		return () => {
			didCancel = true;
		};
	}, [/*idsDirection, idsVersion,idsSection, */language, findText, researchmarket, preview, ready, standart, addStandart, promotion, multistream, multistreamno, msa, platform, microservice, web, nav, dateto, datefrom, bank, archive, findText, window.location.pathname.indexOf("/applications/apptags") > -1 ? arrayTags : null])

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			if (cardArr.length > 0 && window.location.href.indexOf('cftbank') > -1) {
				_loadingKloStatuses(true);
				const statuses = await props.getKloStatuses(cardArr.filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 }).map(el => el.codeasvul).join(','))
				//console.log(statuses)
				_kloStatuses(statuses);
				const allstatuses = await props.getKloStatuses(cardArr.map(el => el.codeasvul).join(','))
				//console.log(statuses)
				_kloStatuses(allstatuses);
				//_initial(false)		
				_loadingKloStatuses(false);
			}
		}
		if (!didCancel && canUpdateData) {
			fetchData();
		}
		return () => {
			didCancel = true;
		};
	}, [cardArr3, currentServerPart]);

	useEffect(() => {
		let didCancel = false;

		let compareStatuses = (app) => {
			let kloStatus = kloStatuses[app.codeasvul];
			let { status, hasDecision, usage } = typeof kloStatus === 'object' ? kloStatus : { status: 'Нет данных', hasDecision: false };
			status = status.toLowerCase()
			if (kloUser.user.IS_BANK === '1') {
				status = status.replace(' (ИСПОЛЬЗУЕТСЯ)', '').replace(' (НЕ ИСПОЛЬЗУЕТСЯ)', '')
			}
			let availableStatusArr = filterStatusKlo.map(el => el.id.toLowerCase())
			//console.log(app.codeasvul,status, hasDecision, usage )
			//  if (hasDecision){
			// console.log(availableStatusArr,availableStatusArr.includes('в процессе оформления покупки (используется)') ,status.indexOf('используется') > -1, hasDecision, status)
			//  } ( hasDecision === true && ( statuses.includes('В ПРОЦЕССЕ ОФОРМЛЕНИЯ ПОКУПКИ (ИСПОЛЬЗУЕТСЯ)') && /*status.indexOf('(ИСПОЛЬЗУЕТСЯ)') > -1*/ usage ===  '(ИСПОЛЬЗУЕТСЯ)' || statuses.includes('В ПРОЦЕССЕ ОФОРМЛЕНИЯ ПОКУПКИ (НЕ ИСПОЛЬЗУЕТСЯ)') && /*status.indexOf('(НЕ ИСПОЛЬЗУЕТСЯ)') > -1*/usage ===  '(НЕ ИСПОЛЬЗУЕТСЯ)'))
			return availableStatusArr.includes(status) && hasDecision === false || (hasDecision === true && status !== 'куплено' && (availableStatusArr.includes('в процессе оформления покупки (используется)') && usage === '(ИСПОЛЬЗУЕТСЯ)' || availableStatusArr.includes('в процессе оформления покупки (не используется)') && usage === '(НЕ ИСПОЛЬЗУЕТСЯ)'))
		}
		if (!didCancel && /*cardArr.length > 0*/ window.location.href.indexOf('cftbank') > -1 && canUpdateData) {
			let filteredArr = filterStatusKlo.length === 0 ? cardArr3 : cardArr3.filter(el => compareStatuses(el))
			setCardArr(filteredArr);
			setCardArr2(filteredArr);
			setcountApp(filteredArr.length)
		}
		return () => {
			didCancel = true;
		};
	}, [filterStatusKlo, cardArr3, kloStatuses]);

	useEffect(() => {
		let didCancel = false;
		async function fetchData() {
			let apps = [].concat(cardArr);
			if (sortingSelectVal === 'recomended') {
				apps = apps.sort(compareApps).map(el => {el.relev = getRelevantNumEqual(el); return el}).sort(/*sortSearchReasultByRelevant*/ (a,b) => b.relev - a.relev);					
			} else {
				console.log("sortingSelectVal",sortingSelectVal)
				apps = sortArrayByDirection(apps.sort(compareApps), idsDirection) || [];

					

				if (sortingSelectVal.at(-1) === 'A') {
					if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
						sortArray(apps)
					} else {
						apps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] < b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
					}
				} else {
					if (sortingSelectVal.slice(0, -1) === 'codeAsvulSort') {
						apps.reverse()
					} else {
						apps.sort((a, b) => a[sortingSelectVal.slice(0, -1)] > b[sortingSelectVal.slice(0, -1)] ? 1 : -1)
					}
				}
			}

			setCardArr(apps);
			setCardArr2(apps)

			
			
		}
		if (!didCancel ) {
			fetchData();
		}
		return () => {
			didCancel = true;
		};
	}, [sortingSelectVal]);

	const filteredSearchFunc = (arr, value) => {
		// console.log("filteredSearchFunc",value, arr, bank)
		if (!utils.hasProperty(value)) {
			return []
		}

		let array = arr.filter(el => (el.url_catalog && Array.isArray(el.url_catalog) && el.url_catalog.includes(bank)) && el.searchValue.toLowerCase().trim().indexOf(value.toLowerCase().trim()) > -1).sort((a, b) => { return b.relev - a.relev }).slice(0, 6);

		return array
	}

	const getParamURLQuerySection = async (srt, param) => {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'section=') {
				return (+Val)
			}
		}
	}

	const setIdsVersion = (ids) => {
		setPage(1)
		if (idsVersion.length > 0 && idsVersion.some(el => el.ID === ids.ID)) {
			if (idsVersion.length === 1 && idsVersionFilter.length < versionArr.filter(elem => { return cardArr.map(item => item.version).includes(elem.Version) })) {
				_idsVersionFilter(false);
			}
			_idsVersion(idsVersion.filter(el => el.ID !== ids.ID))
			if (idsVersion.filter(el => el.ID !== ids.ID).length === 0) {
				setValueFilterStatuses(1);
				_ready(0); _preview(0); _researchmarket(0);
			}

		} else {
			// if (idsVersion.length === 0 && idsVersionFilter === false) {
			// 	_idsVersionFilter(versionArr.filter(elem => { return cardArr.map(item => item.version).includes(elem.Version) }))
			// }
			//setValueFilterStatuses(4);
			//if (!isArchive2){_ready(1)}; _preview(0); _researchmarket(0);
			_idsVersion(idsVersion.concat([ids]));


		}

		console.log('setIdsVersion', idsVersion.length)

	}

	const setIdsSection = (ids) => {
		setPage(1)
		if (idsSection.length > 0 && idsSection.some(el => el.ID === ids.ID)) {
			if (idsSection.length === 1 && idsSectionFilter.length < sectionArr.filter(elem => { return cardArr.map(item => item.sectionid).includes(elem.ID) })) {
				_idsSectionFilter(false)
			}
			_idsSection(idsSection.filter(el => el.ID !== ids.ID))
		} else {
			// if (idsSection.length === 0 && idsSectionFilter === false) {
			// 	_idsSectionFilter(sectionArr.filter(elem => { return cardArr.map(item => item.sectionid).includes(elem.ID) }))
			// }
			_idsSection(idsSection.concat([ids]))
		}

	}


	const setIdsDirection = (ids) => {
		setPage(1)
		if (idsDirection.length > 0 && idsDirection.some(el => el.ID_BN === ids.ID_BN)) {
			if (idsDirection.length === 1 && idsDirectionFilter.length < directionArr.filter(elem => { return cardArr.map(item => item.businessdirectionid).includes(elem.ID_BN) }).length) {
				_idsDirectionFilter(false)
			}
			_idsDirection(idsDirection.filter(el => el.ID_BN !== ids.ID_BN))
		} else {
			// if (idsDirection.length === 0 && idsDirectionFilter === false) {
			// 	_idsDirectionFilter(directionArr.filter(elem => { return cardArr.map(item => item.businessdirectionid).includes(elem.ID_BN) }))
			// }
			_idsDirection(idsDirection.concat([ids]))
		}


	}

	const setIdsVersionFilter = () => {
		_idsVersionFilter(idsVersion);
	}

	const setIdsSectionFilter = () => {
		_idsSectionFilter(idsSection);
	}


	const setIdsDirectionFilter = () => {
		_idsDirectionFilter(idsDirection);
	}

	const setAllFilters = () => {
		setIdsVersionFilter();
		setIdsSectionFilter();
		setIdsDirectionFilter();
	}

	useEffect(() => {
		if (window.innerWidth < 1366) {
			setView('tile')
		}
	}, [window.innerWidth]);

	const handleChangeFilterStatuses = (event) => {
		setValueFilterStatuses(+event.target.value);
		switch (+event.target.value) {
			case 1: { _researchmarket(0); _preview(0); _ready(0); break; }
			case 2: { source.cancel('Operation canceled by the user.'); setStatusFilter(true); _preview(0); _ready(0); _researchmarket(1); break; }
			case 3: { source.cancel('Operation canceled by the user.'); setStatusFilter(true); _preview(1); _ready(0); _researchmarket(0); break; }
			case 4: { source.cancel('Operation canceled by the user.'); setStatusFilter(true); _ready(1); _preview(0); _researchmarket(0); break; }
			default: { _researchmarket(0); _preview(0); _ready(0); break; }
		}
	};

	const handleChangeFilterShowApplications = (event) => {
		setValueFilterShowApplications(+event.target.value);
		switch (+event.target.value) {
			case 1: { _multistream(0); _multistreamno(0); break; }
			case 2: { source.cancel('Operation canceled by the user.'); setStatusFilter(true); _multistreamno(0); _multistream(1); break; }
			case 3: { source.cancel('Operation canceled by the user.'); setStatusFilter(true); _multistreamno(1); _multistream(0); break; }
			default: { _multistream(0); _multistreamno(0); break; }
		}
	};

	const handleChangeFilterArchive = (event) => {
		setValueFilterArchive(+event.target.value);
		switch (+event.target.value) {
			case 1: { _archive(0); break; }
			case 2: { source.cancel('Operation canceled by the user.'); _archive(1); break; }
			default: _archive(0)
		}
	};

	const click_promotion = () => {
		setPage(1)

		if (promotion === '1') {
			source.cancel('Operation canceled by the user.');
			_promotion('0')
		} else {
			source.cancel('Operation canceled by the user.');
			setStatusFilter(true);
			_promotion('1')
		}
	}

	const click_video = () => {
		setPage(1);
		source.cancel('Operation canceled by the user.');
		_video(video === '1' ? '0' : '1')
	}

	const click_cloud = () => {
		setPage(1);

		if (hasCloud === '1') {
			source.cancel('Operation canceled by the user.');
			_hasCloud('0')
		} else {
			source.cancel('Operation canceled by the user.');
			setStatusFilter(true);
			_hasCloud('1')
		}
	}

	const click_standart = () => {
		setPage(1)
		source.cancel('Operation canceled by the user.');

		if (standart === '1') {
			_standart('0')
		} else {
			setStatusFilter(true)
			_standart('1')
		}
	}

	const click_addStandart = () => {
		source.cancel('Operation canceled by the user.');
		setPage(1)
		addStandart === '1' ? _addStandart('0') : _addStandart('1')
	}
	/*********************************************************************** */
	const choiseAll = async (event) => {
		let newCardID = filterSearchResult(cardArr).filter(elem => elem.researchmarket === '' && !props.userCollection.appCartInProduct.includes(elem.ID)).map(elem => elem.ID)//dataCardID && dataCardID.data
		let basketApps_ = props.userCollection.appBasket;
		let basketApp = allCheckBox ? basketApps_.filter(item => !newCardID.includes(item)) : basketApps_.concat(newCardID.filter(item => !basketApps_.includes(item)));
		props.saveCollection(basketApp, 'app', 'cart', undefined, true);
		setCheckAll(!checkAll)
		if (!allCheckBox) {
			let deltaApps = basketApp.length - basketApps_.length;
			props.handleCloseCookieSnackbar();
			_snackbar([true, translate.Words[`AddtoCartApps_${language}`] + ": " + deltaApps])
		}

		//window.location.reload()
	}

	useEffect(() => {
		let basketApp = props.userCollection.appBasket.concat(props.userCollection.appCartInProduct) || []
		// let isAll = cardArr.every(el => basketApp.includes(el.ID))

		let isAllBasket = cardArr && cardArr.filter(el => el.researchmarket == "")
		let isAll = isAllBasket && isAllBasket.every(el => basketApp.includes(el.ID))

		setAllCheckBox(isAll)
	}, [cardArr, checkAll, props.userCollection.appBasket]);

	const filterData = (array, aviableValues, isDirection = false) => {
		let prop = !isDirection ? 'ID' : 'ID_BN';
		return aviableValues.length > 0 ? array.filter(elem => { return aviableValues.map(item => item[prop]).includes(elem[prop]) }) : array
	}

	//  cardArr.filter((elem, index) => { console.log (index < page *24)
	// 	return page   < index })

	//console.log(cardArr.filter((elem, index) => { return index <= page *24 && index > (page-1) * 24 }), page)
	const StyledBadge = withStyles((theme) => ({
		badge: {
			top: 1,
			right: 3,
			height: 8,
			width: 8,
			borderRadius: 5,
			backgroundColor: '#EB505E'
		},
	}))(Badge);

	const accurateSearchIconFill = showAccurateSearchMenu ? '#3C3C56' : '#BCBBD0';
	const checkSearchCondition = (elem, prop, search) => {
		let string = ['HTMLContent', 'HTMLFunction'].includes(prop) ? elem[prop].replace(/[<.>]/g, ' ')/*.replace(/>/g, ' ')*/.toLowerCase() : elem[prop].toLowerCase();
		string = " " + string + " "
		//console.log(string, search, string.indexOf(` ${search} `) > -1)
		return (
			string === search || /*string.indexOf(`${search} `) > -1 || */string.indexOf(` ${search} `) > -1 //|| string.indexOf(` ${search}`) > -1
			//|| string.slice(0,search.length) === search || string.slice(-search.length) === search 
		)
	}
	const filterSearchResult = (array) => {
		if (accurateSearch && findText !== '' && false) {
			let find = findText.toLowerCase();
			return array.filter(elem => {
				return (checkSearchCondition(elem, 'codeasvul', find)
					|| checkSearchCondition(elem, 'briefdescription', find)
					|| checkSearchCondition(elem, 'title', find)
					|| checkSearchCondition(elem, 'HTMLContent', find)
					|| checkSearchCondition(elem, 'HTMLFunction', find)
				)
			})
		} else {
			return array
		}

	}

	const renderSearchInfo = () => {
		if (rusSearch !== '' && language === 'Ru' && !accurateSearch) {
			return (
				<Typography className={classes.FoundApps}>По запросу "{findText}" ничего не найдено. Показаны результаты по запросу "{rusSearch}".
					<br /> {translate.Words[`FoundApps${language}`]}{filterSearchResult(cardArr).length}</Typography>
			)
		} else {
			return (
				<Typography className={classes.FoundApps}>{translate.Words[`FoundApps${language}`]}{filterSearchResult(cardArr).length}</Typography>
			)
		}
	}

	function upPrioritySnackbar(ResearchMarketMails, codeasvul) {
		props.handleCloseCookieSnackbar()
		_snackbar([true, translate.Words[`HasBeenRaised${language}`]])
		upPriority(ResearchMarketMails, codeasvul)
	}

	async function upPriority(ResearchMarketMails, codeasvul, onSuccess) {
		let toJson = ResearchMarketMails && ResearchMarketMails.length > 1 ? JSON.parse(ResearchMarketMails) : {}
		toJson[`${props.usname.email}`] = 1;

		_disablePriorityBtn(disablePriorityBtn.concat(codeasvul))

		// console.log(disablePriorityBtn, disablePriorityBtn.concat(codeasvul));

		// setMails(JSON.stringify(toJson))
		const result = await axios.post(`${serverAPI}/uppriority`, { mails: JSON.stringify(toJson), asvul: codeasvul })
		if (result) { } // codeerr пока заглушка
	}

	const textInput = useRef(null);
	let allAppVersions = [];
	cardArr.map(el => {
		let vers = [];
		try {
			vers = JSON.parse(el.additional_versions)
		} catch (e) {
			//console.log('catchParseVers',e)
			vers = [];
		}
		allAppVersions.push(el.version, ...vers)
	})
	//console.log(allAppVersions)
	return (

		<React.Fragment>
			<Grid container style={{ marginTop: 45 }}>
				<Grid item container spacing={3} style={{ alignItems: 'center', }}>
					{
						window.location.pathname.indexOf("/applications/apptags") > -1
							?
							<Grid item container className={classes.cntrPageHeader} style={{ flexGrow: 1 }}>
								<Typography component="h1" className={classes.PageHeader}>{language === 'Ru' ? "Поиск по тегам" : "Search by tags"}</Typography>
							</Grid>
							:
							<Grid item container className={classes.search}
								style={{
									background: searchFocus ? '#fff' : '#EEEEF5',
									boxShadow: searchFocus ? '6px 6px 18px rgba(35, 72, 152, 0.08)' : undefined,
									padding: '0 12px'
								}}
							>
								<Grid item className={classes.searchIcon}>
									<SearchIcon fill={'#BCBBD0'} />
								</Grid>
								{/* <ClickAwayListener onClickAway={(e) => {
									// if (anchorMenu.current && anchorMenu.current.contains(e.target)) {
									// 	return;
									// }
									setSearchFocus(false)
								}}> */}
								{/* <InputBase
										onKeyDown={(e) => { handleKeyDown(e, e.target.value); setPage(1) }}
										//value={text}
										//onChange={(e) => setText(e.target.value)}
										ref={textInput}
										placeholder={translate.Words[`ApplicationSearch${language}`]}
										classes={{
											root: classes.inputRoot,
											focused: classes.inputFocused,
											input: classes.inputInput
										}}
										inputProps={{ 'aria-label': 'search' }}
										onFocus={() => setSearchFocus(true)}

									/> */}
								<CustomAutocomplete
									ref={textInput}
									//defaultValue={getDefaultParamURLQuery(history.location.search, 'q=')}
									//onChange={(e,value) => setSearchText(value)}
									inputId='appsSearchInput'
									id={'appsSearchInput'}
									label={translate.Words[`ApplicationSearch${language}`]}
									//onFocus={(e) => setSearchFocus(false)}
									onBlur={() => setSearchFocus(!searchFocus)}
									onKeyDown={(val) => { handleKeyDown(val); setPage(1) }}
									//value={searchText}
									options={props.searchPhrases}
									filteredSearchFunc={filteredSearchFunc}
								/>
								{/* </ClickAwayListener> */}

								{/* НИЖЕ КНОПКА ОЧИЩЕНИЯ СТРОКИ ПОИСКА */}
								<div
									className={classes.inputCloseBtn}
								>
									<IconButton
										aria-controls={showAccurateSearchMenu ? 'accurate-search-menu' : undefined}
										onClick={(e) => { _anchorMenu(e.currentTarget); _showAccurateSearchMenu(!showAccurateSearchMenu); }}
									>
										{accurateSearch
											?
											<StyledBadge
												color="secondary"
												variant="dot"
											//className ={classes.styledBadge}
											>

												<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect x="4" y="5" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
													<rect x="4" y="17" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
													<rect x="4" y="11" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
													<circle cx="9" cy="6" r="3" fill={accurateSearchIconFill} />
													<circle cx="9" cy="18" r="3" fill={accurateSearchIconFill} />
													<circle cx="15" cy="12" r="3" fill={accurateSearchIconFill} />
													<circle cx="9" cy="6" r="1" fill="#EEEEF5" />
													<circle cx="9" cy="18" r="1" fill="#EEEEF5" />
													<circle cx="15" cy="12" r="1" fill="#EEEEF5" />
												</svg>


											</StyledBadge>
											:
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="4" y="5" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
												<rect x="4" y="17" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
												<rect x="4" y="11" width="16" height="2" rx="1" fill={accurateSearchIconFill} />
												<circle cx="9" cy="6" r="3" fill={accurateSearchIconFill} />
												<circle cx="9" cy="18" r="3" fill={accurateSearchIconFill} />
												<circle cx="15" cy="12" r="3" fill={accurateSearchIconFill} />
												<circle cx="9" cy="6" r="1" fill="#EEEEF5" />
												<circle cx="9" cy="18" r="1" fill="#EEEEF5" />
												<circle cx="15" cy="12" r="1" fill="#EEEEF5" />
											</svg>


										}

									</IconButton>
									<IconButton aria-label="add to favorites"
										onClick={() => { clearSearch(); setPage(1) }}
									>
										<CloseIcon fill={'#BCBBD0'} />
									</IconButton>
								</div>
							</Grid>
					}

					{/* Точный Поиск */}
					<Popper open={showAccurateSearchMenu} anchorEl={anchorMenu} role={undefined} transition disablePortal placement={'bottom'}

						modifiers={{
							offset: {
								enabled: true,
								offset: "28, 5"
							}
						}}
					>
						{({ TransitionProps, placement }) => (
							<Grow
								{...TransitionProps}
								style={{ transformOrigin: placement === 'bottom' ? 'left bottom' : 'left top' }}
							>
								<ClickAwayListener onClickAway={(e) => {
									if (anchorMenu.current && anchorMenu.current.contains(e.target)) {
										return;
									}
									_showAccurateSearchMenu(false)
								}}>
									<Paper style={{
										maxHeight: 416, boxShadow: '4px 4px 30px rgba(35, 72, 152, 0.2)',
										borderRadius: '16px',
										//paddingTop: '8px',
										padding: '8px 32px 8px 15px',
										//paddingBottom: '8px'
										overflow: 'auto',
										width: 315

									}}
										className={classes.customMenuBody}
									>
										<Grid
											//className={classes.list}
											item
											container
											direction="column"
											justify="space-between"
											alignItems="stretch"
										>
											<FormControlLabel
												onChange={() => { _showAccurateSearchMenu(false); _accurateSearch(!accurateSearch); setPage(1) }}
												className={classes.formControl}
												value={accurateSearch}
												style={{ width: '100%', margin: '0 auto' }}
												control={
													<CustomCheckbox checked={accurateSearch} className={classes.customMenuCheckBox} />
												}
												label={
													<Typography className={classes.customMenuCheckBoxLabel}>
														{translate.Words[`AccurateSearch${language}`]}
													</Typography>
												}
												labelPlacement="end"
											/>
										</Grid>
									</Paper>
								</ClickAwayListener>
							</Grow>
						)}
					</Popper>

					<Grid item>
						{//!isArchive
							archive == 0 && researchmarket == 0 && !isArchive2
								?
								<CustomTooltip title={translate.Words[`AddAllToBasket${language}`]}>
									<Button aria-label="delete" className={classes.margin} size="small" onClick={(e) => choiseAll(e)} style={{ height: 48, display: allCheckBox ? 'none' : '' }}>
										<AddAllAppsIcon fill={'#BCBBD0'} fontSize="inherit" />
										<Typography className={classes.btnAddAlltxt}>{translate.Words[`AddAllToBasket${language}`]} </Typography>
									</Button>
								</CustomTooltip>
								:
								null
						}
					</Grid>

					<Grid item style={{ width: 224, display: view === 'tbl' ? 'none' : 'block' }}>
						<CustomSelect
							data={
								findText && findText.length > 2
								?
								[
									{ id: 'codeAsvulSortA', name: language === 'Ru' ? 'По коду \u{1F856}' : 'By code \u{1F856}' }, // 🡖
									{ id: 'codeAsvulSortD', name: language === 'Ru' ? 'По коду \u{1F855}' : 'By code \u{1F855}' }, // 🡕
									{ id: 'sortingdatestartsaleD', name: language === 'Ru' ? 'По дате выпуска \u{1F855}' : 'By release date \u{1F855}' },
									{ id: 'sortingdatestartsaleA', name: language === 'Ru' ? 'По дате выпуска \u{1F856}' : 'By release date \u{1F856}' },
									{ id: 'versionD', name: language === 'Ru' ? 'По версии \u{1F855}' : 'By version \u{1F855}' },
									{ id: 'versionA', name: language === 'Ru' ? 'По версии \u{1F856}' : 'By version \u{1F856}' },
									{ id: 'recomended', name:language === 'Ru' ?  'Рекомендуемое' : 'Recommended'}
								]
								:
								[
									{ id: 'codeAsvulSortA', name: language === 'Ru' ? 'По коду \u{1F856}' : 'By code \u{1F856}' }, // 🡖
									{ id: 'codeAsvulSortD', name: language === 'Ru' ? 'По коду \u{1F855}' : 'By code \u{1F855}' }, // 🡕
									{ id: 'sortingdatestartsaleD', name: language === 'Ru' ? 'По дате выпуска \u{1F855}' : 'By release date \u{1F855}' },
									{ id: 'sortingdatestartsaleA', name: language === 'Ru' ? 'По дате выпуска \u{1F856}' : 'By release date \u{1F856}' },
									{ id: 'versionD', name: language === 'Ru' ? 'По версии \u{1F855}' : 'By version \u{1F855}' },
									{ id: 'versionA', name: language === 'Ru' ? 'По версии \u{1F856}' : 'By version \u{1F856}' },									
								]
							}
							tooltip={translate.Words[`Sorting_${language}`]}
							//defaultValue={sortingSelectVal}
							value = {sortingSelectVal}
							func={(e) => _sortingSelectVal(e.target.value)}
						/>
					</Grid>

					<Grid item className={classes.betweenCnt}></Grid>

					<Grid item className={classes.cntrChangeView}>
						<ChangeViewArray
							selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2}
							handleView={setView}
							// handleCount={setRecord}
							page={window.innerWidth > 1365 ? 'applist' : ''}
						/>
					</Grid>

					{/* ===== ФИЛЬТРЫ =============== */}

					<Grid item>
						<React.Fragment>
							{
								window.location.pathname.indexOf("/applications/apptags") > -1
									?
									null
									:
									<CustomTooltip title={translate.Words[`Filter${language}`]}>
										<IconButton onClick={() => setFilterOpen(true)} aria-label="filter" className={classes.btnFilter}>
											{statusFilter || filterStatusKlo.length > 0 ?
												<StyledBadge
													color="secondary"
													variant="dot"
												>
													<FilterIcon />
												</StyledBadge>
												:
												<FilterIcon />}
										</IconButton>
									</CustomTooltip>
							}

							<Drawer
								anchor={"right"}
								open={filterOpen}
								onClose={() => setFilterOpen(false)}
							// className={classes.root}
							>
								<Grid item className={classes.FilterHeaderCntr}>
									{FilterHeader()}
								</Grid>

								<Grid style={{ height: 'calc(100% - 108px)', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}>
									<Grid item container direction="column" className={classes.FilterBodyCntr} style={{ padding: '0 24px' , width:344}}>
										{useMemo(() =>
											<FilterStatuses		// Статус
												handleChange={handleChangeFilterStatuses}
												value={valueFilterStatuses}
												isRBS={isRBS}
												isArchive={isArchive}
											/>
											, [valueFilterStatuses]
										)}

										<Divider />

										{/* {
											!isRBS 
											?
									 */}

										<FilterShow
											standart={standart}
											promotion={promotion}
											addStandart={addStandart}
											click_addStandart={click_addStandart}
											click_standart={click_standart}
											click_promotion={click_promotion}
											isRBS={isRBS}
											isArchive={isArchive}
											hasVideo={hasVideo}
											catalog = {props.info}
										/>
										{/* : null
											} */}

										{
											// isCFTBank
											// 	?
											<FilterShowApplicationsRadio		// Отображать Приложения
												isArchive={isArchive}
												hasVideo={hasVideo}
												isCFTBank={isCFTBank}
												handleChange={handleChangeFilterShowApplications}
												value={valueFilterShowApplications}
											/>
											// :
											// null
										}

										{
											isCFTBank
												?
												<Divider />
												:
												null
										}

										{
											!isArchive
												?
												<FilterArchive		// Архив
													isArchive={isArchive}
													isCFTBank={isCFTBank}
													disabled={researchmarket === 1}
													handleChange={handleChangeFilterArchive}
													value={valueFilterArchive}
													hasVideo={hasVideo}
												/>
												:
												null
										}

										{
											hasCloudApps
												?
												<React.Fragment>
													<Divider />

													<FilterShowCloudApps		// Облачное
														hasCloud={hasCloud}
														action={click_cloud}
													/>
												</React.Fragment>
												:
												null
										}

										{
											hasVideo
												?
												<React.Fragment>
													<Divider />
													<FilterShowVideo		// С видео
														video={video}
														click_video={click_video}
														isRBS={isRBS}
														isArchive={isArchive}
														hasVideo={hasVideo}
													/>
												</React.Fragment>
												:
												null
										}

										{researchmarket === 1 ? '' :
											<FormControl component="fieldset" style={{ maxWidth: 285 }}>
												<Typography className={classes.header}>{translate.Words[`Version${language}`]}:</Typography>
												<SubFilterList data={idsVersionFilter === false ? versionArr.filter(elem => allAppVersions.includes(elem.Version)) : idsVersionFilter} ids={idsVersion} key1={'ID'} key2={'Version'} setBefore={setIdsVersion} header={translate.Words[`Version${language}`]} paramName='version' onClose={() => { _idsVersionFilter(false) }} close={setScreenVersionBeforeVisibleProps} onOpen={() => { _idsVersionFilter(versionArr.filter(elem => allAppVersions.includes(elem.Version))) }} />
												<Grid item style={{ paddingTop: 8 }}>
													<ChipArrayRed chipData={idsVersion} key1={'ID'} key2={`Version`} handleDelete={setIdsVersion} />
												</Grid>
											</FormControl>
										}

										<FormControl component="fieldset" style={{ maxWidth: 285 }}>
											<Typography className={classes.header}>{translate.Words[`ReleaseDate${language}`]}:</Typography>
										</FormControl>

										<Grid container justify="space-between" style={{ marginTop: 20, maxWidth: 285 }}>
											<Fragment>
												<MuiPickersUtilsProvider utils={MomentUtils} locale={language}>
													<DatePicker
														autoOk
														variant="inline"
														inputVariant="outlined"
														label={translate.Words[`To${language}1`]}
														format="DD/MM/yyyy"
														value={selectedDateFrom}
														InputAdornmentProps={{ position: "start" }}
														onChange={date => handleDateChangeFrom(date)}
														style={{
															width: '132px',
															borderBottomColor: '#F6F6FB',
															backgroundColor: '#F6F6FB',
															border: 'none'
														}}
													/>

													<DatePicker
														autoOk
														variant="inline"
														inputVariant="outlined"
														label={translate.Words[`To${language}2`]}
														format="DD/MM/yyyy"
														value={selectedDateTo}
														InputAdornmentProps={{ position: "start" }}
														onChange={date => handleDateChangeTo(date)}
														style={{
															width: '132px',
															borderBottomColor: '#F6F6FB',
															backgroundColor: '#F6F6FB',
															border: 'none'
														}}
													/>
												</MuiPickersUtilsProvider>
											</Fragment>
										</Grid>

										<FormControl component="fieldset" style={{ maxWidth: 285 }}>
											<Typography className={classes.header}>{translate.Words[`BusinessArea${language}`]}:</Typography>
											<SubFilterList data={idsDirectionFilter === false ? directionArr.filter(elem => { return cardArr.map(item => item.businessdirectionid).includes(elem.ID_BN) }) : idsDirectionFilter} ids={idsDirection} key1={'ID_BN'} key2={'Title'} setBefore={setIdsDirection} header={translate.Words[`BusinessArea${language}`]} paramName='direction' close={setScreenDirectionVisibleProps} onClose={() => { _idsDirectionFilter(false) }}
												onOpen={() => { _idsDirectionFilter(directionArr.filter(elem => { return cardArr.map(item => item.businessdirectionid).includes(elem.ID_BN) })) }} />
											<Grid item style={{ paddingTop: 8 }}>
												<ChipArrayRed chipData={idsDirection} key2={`Title`} handleDelete={setIdsDirection} />
											</Grid>
										</FormControl>

										<FormControl component="fieldset" style={{ maxWidth: 285 }}>
											<Typography className={classes.header}>{translate.Words[`Section${language}`]}:</Typography>
											<SubFilterList systema={bank} data={idsSectionFilter === false ? sectionArr.filter(elem => { return cardArr.map(item => item.sectionid).includes(elem.ID) }) : idsSectionFilter} key1='ID' key2={`TitileSectionRu`} ids={idsSection} setBefore={setIdsSection} header={translate.Words[`Section${language}`]} paramName='section' close={setScreenSectionVisibleProps} onClose={() => { _idsSectionFilter(false) }} onOpen={() => { _idsSectionFilter(sectionArr.filter(elem => { return cardArr.map(item => item.sectionid).includes(elem.ID) })) }} />
											<Grid item style={{ paddingTop: 8 }}>
												<ChipArrayRed chipData={idsSection} key1={'ID'} key2={`TitileSectionRu`} handleDelete={setIdsSection} />
											</Grid>
										</FormControl>

										{
											props.info.hasInterface === 1//!isRBS && !isServiceSuite && !isBudget && !isManagementRisks
												?
												<FilterInterface
													nav={nav}
													_nav={_nav}
													web={web}
													_web={_web}
												/>
												:
												null
										}

										{
											props.info.hasArchitecture === 1//!isRBS && !isServiceSuite && !isBudget && !isManagementRisks
												? <FilterArchitecture
													platform={platform}
													_platform={_platform}
													msa={msa}
													_msa={_msa}
													microservice={microservice}
													_microservice={_microservice}
												/>
												:
												<Grid style={{ width: 292 }} />
										}

										{
											isCFTBank && kloUser && kloUser.user && Object.keys(kloStatuses).length > 0
												?
												<FormControl component="fieldset" style={{ maxWidth: 285 }}>
													<Typography className={classes.header}>{'Статус КЛО'}:</Typography>
													<SubFilterList systema={props.bank} data={availableStatuses.map(item => { return { title: item, id: item } })} key1='id' key2={`title`} ids={filterStatusKlo} header={'Статус КЛО'} paramName='section' setBefore={(item) => { _filterStatusKlo(filterStatusKlo.map(el => el.id).includes(item.id) ? filterStatusKlo.filter(el => el.id !== item.id) : filterStatusKlo.concat(item)) }} />
													<Grid item style={{ paddingTop: 8 }}>
														<ChipArrayRed chipData={filterStatusKlo} key1={'id'} key2={`title`} handleDelete={(item) => _filterStatusKlo(filterStatusKlo.filter(el => el.id !== item.id))} />
													</Grid>
												</FormControl>
												:
												null
										}
									</Grid>
								</Grid>

								<Grid item className={classes.FilterActionCntr}>
									<FilterButton variant="contained" className={classes.btnSecondary} onClick={() => resetStateNew()}>{translate.Words[`ResetFilters${language}`]}</FilterButton>
								</Grid>
							</Drawer>
						</React.Fragment >
					</Grid>

					{/* =============== ФИЛЬТРЫ ===== */}
				</Grid>

				<Grid item container spacing={3} id={'1245'} style={{ margin: '0 -12px' }} >
					{
						statusFilter || findText !== '' || (filterStatusKlo.length > 0 && filterSearchResult(cardArr).length > 0 || isArchive === 1)
							?
							renderSearchInfo()
							:
							null
					}

					{view === 'tile' ? loading === true || (loadingKloStatuses && filterStatusKlo.length > 0)
						?
						<Grid item container spacing={3} style={{ marginTop: 0 }}>
							<SkeletonCardTable />
						</Grid>
						:
						cardArr.length > 0
							?
							<AllAppsTable
								page={page}
								apps_paginator={true}
								arrayTag={arrayTag}
								setArrayTag={setArrayTag}
								basket={true}
								cart={false}
								type={'applications'}
								readLink={info.LinkActive === 0}
								cardArr={filterSearchResult(cardArr).filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
								bank={props.bank}
								catalog={props.info}
								checkAll={checkAll}
								setCheckAll={setCheckAll}
								upPriority={upPrioritySnackbar}
								disablePriorityBtn={disablePriorityBtn}
								clearChips={clearChips}
								usname={props.usname}
								onScroll={(e) => console.log(e)}
								kloStatuses={kloStatuses}
								kloUser={kloUser}
								loadingKloStatuses={loadingKloStatuses}
								userCollection={props.userCollection}
								saveCollection={props.saveCollection}
							/>
							:
							<FilterErr />
						:
						view === 'table' ? loading === true || (loadingKloStatuses && filterStatusKlo.length > 0)
							?
							<SkeletonCardTile />
							:
							cardArr.length > 0
								?
								<AllAppsTile
									page={page}
									apps_paginator={true}
									arrayTag={arrayTag}
									setArrayTag={setArrayTag}
									basket={true}
									cart={false}
									type={'applications'}
									language={language}
									readLink={info.LinkActive === 0}
									cardArr={filterSearchResult(cardArr).filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
									bank={props.bank}
									catalog={props.info}
									checkAll={checkAll}
									setCheckAll={setCheckAll}
									upPriority={upPrioritySnackbar}
									clearChips={clearChips}
									usname={props.usname}
									disablePriorityBtn={disablePriorityBtn}
									onScroll={(e) => console.log(e)}
									kloStatuses={kloStatuses}
									kloUser={kloUser}
									loadingKloStatuses={loadingKloStatuses}
									userCollection={props.userCollection}
									saveCollection={props.saveCollection}
								/>
								:
								<FilterErr />
							:
							<AllAppsTbl key={3}
								arrayTag={arrayTag}
								setArrayTag={setArrayTag}
								basket={true}
								cart={false}
								type={'applications'}
								readLink={info.LinkActive === 0}
								cardArr={filterSearchResult(cardArr2)}
								bank={props.bank}
								catalog={props.info}
								checkAll={checkAll}
								setCheckAll={setCheckAll}
								loading={loading || (loadingKloStatuses && filterStatusKlo.length > 0)}
								err={<FilterErr />}
								upPriority={upPrioritySnackbar}
								clearChips={clearChips}
								usname={props.usname}
								disablePriorityBtn={disablePriorityBtn}
								onScroll={(e) => console.log(e)}
								kloStatuses={kloStatuses}
								kloUser={kloUser}
								loadingKloStatuses={loadingKloStatuses}
								idsDirection={idsDirection}
								userCollection={props.userCollection}
								saveCollection={props.saveCollection}
								init = {sortingSelectVal === 'recomended'}
								parent = {'catalog'}
							/>
					}

					{view !== 'tbl' && filterSearchResult(cardArr2).length > 0
						?
						<Grid item container style={{ display: Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 32, /*position:props.showPagination ?  '' : 'fixed' , bottom:'0px',background: props.showPagination ? undefined :'#F4F5FB',*/ paddingLeft: 12, alignItems: 'center' }} >
							{
								Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) > 0
									?
									<Pagination id='pagination-js' style={{ 'visible': 'hidden', transition: 'opacity 0.6s linear' }} className={classes.newPagination} count={Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) + 1} siblingCount={window.innerWidth < 696 ? 0 : 1} page={page} onChange={changePage} />
									:
									null
							}
							{
								isCFTBank
									?
									<KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser} //delta = {345}
										delta={Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : 345} />
									:
									null
							}
						</Grid>
						:
						null
					}
					{
						view !== 'tbl' && filterSearchResult(cardArr2).length > 0
							?
							<Grid item id='paginationContainer-js' container style={{ display: Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) > 0 || (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', padding: '0 0 0 12px', alignItems: 'center' }} >
								{
									Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) > 0
										?
										<Pagination id='pagination2-js' className={classes.newPagination} count={Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) + 1} siblingCount={window.innerWidth < 696 ? 0 : 1} page={page} onChange={changePage} style={{ transition: 'opacity 0.6s linear' }} />
										:
										null
								}
								{
									isCFTBank
										?
										<KloBanksChoose kloUser={kloUser} _kloUser={props._kloUser} delta={Math.trunc((filterSearchResult(cardArr2).length - 1) / 24) === 0 && (kloUser && Array.isArray(kloUser.banks) && kloUser.banks.length > 0) ? 0.15 : undefined} />
										:
										null
								}
							</Grid>
							:
							null
					}
				</Grid>

				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						open={snackbar[0]}
						autoHideDuration={3000}
						onClose={closeSnackbar}
					// message="Приложение доавлено в корзину"
					// className={classes.root}
					>
						<Grid
							container
							direction="row"
							justify="flex-start"
							alignItems="center"
							className={classes.snackbarPostroot}
						>
							<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
								<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
								</svg>
							</Avatar>

							<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF', width: 'calc(100% - 64px)' }}>
								{snackbar[1]}
							</Typography>
						</Grid>
					</Snackbar>
				</div>
			</Grid>
		</React.Fragment>
	);
}

const useStyles = makeStyles(theme => ({
	// root: {
	// 	display: "flex"
	// },

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: theme.spacing(3),
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	newPagination: {
		display: 'flex',
		alignItems: 'center'
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2)
	},

	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	btnFilter: {
		backgroundColor: '#FFF',
		borderRadius: '16px',
		'&:focus': {
			borderRadius: '16px'
		}
	},

	tHeader: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		fontWeight: 400
	},

	backToList: {
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	search: {
		flexGrow: 1,
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 8,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,
		padding: '0 12px',

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	cntrPageHeader: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
		width: '100%'
	},

	inputFocused: {
		color: '#8987A2',
		width: '100%'
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
		paddingRight: 96,
		transition: theme.transitions.create('width'),
		width: '100%',
		height: 32,

		[theme.breakpoints.up(1366)]: {
			// width: 0,
			'&:focus': {
				width: '100%',
			},
		},

		[theme.breakpoints.down(1366)]: {
			// width: 0,
			'&:focus': {
				// width: 207,
				width: '100%',
			},
		},
		color: '#8987A2'
	},

	inputCloseBtn: {
		position: 'absolute',
		top: 0,
		right: 0,
	},

	inputCloseBtnHide: {
		display: 'none'
	},
	customMenuBody: {
		'&:before': {
			content: '""',
			position: 'absolute',
			left: '116px',
			top: '-33px',
			border: '13.5px solid transparent',
			borderBottom: '21px solid #ffffff'
		}
	},

	customMenuCheckBoxLabel: {
		//margin:'auto 7px'
		marginLeft: 7
	},

	root: {
		flexGrow: 1
	},
	padding: {
		padding: theme.spacing(1)
	},
	demo1: {
		backgroundColor: theme.palette.background.paper
	},
	demo2: {
		backgroundColor: "#2e1534"
	},

	cntrAppCardTop: {
		padding: '36px 0'
	},

	cntrChangeView: {
		marginRight: 0,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},

	filterHeader: {
		fontWeight: 500,
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A'
	},

	list: {
		width: 334,
		overflowX: 'hidden'
	},

	header: {
		marginTop: 20,
		marginBottom: 10,
		fontWeight: 500,
		fontSize: '18px',
		lineHeight: '28px',
		color: '#24262A'
	},

	FilterActionCntr: {
		padding: 24
	},

	snackbarPostroot: {
		padding: 24,
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
	},

	FoundApps: {
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "24px",
		lineHeight: "32px",
		color: "#000000",
		padding: "16px 12px",
	},

	PageHeader: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '28px',
		lineHeight: '40px',
		color: '#000000'
	},

	btnAddAlltxt: {
		marginLeft: 16,
		color: '#8987A2',
		textTransform: 'none',

		[theme.breakpoints.between(1032, 1702)]: {
			display: 'none'
		}
	},

	betweenCnt: {
		width: 'calc(100% - 296px)',

		[theme.breakpoints.up(1031)]: {
			display: 'none'
		}
	}
}));

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);